(function () {
  var formObserver = null;
  var isApplying = false;
  var applyTimeout = null;

  function scheduleApply() {
    if (applyTimeout) clearTimeout(applyTimeout);
    applyTimeout = setTimeout(function () {
      hideSingleOptionFields();
    }, 50);
  }

  function countSelectOptions(selectEl) {
    if (!selectEl) return 0;
    var options = Array.prototype.slice.call(selectEl.options || []);

    return options.filter(function (opt) {
      var value = (opt.value || '').trim().toLowerCase();
      if (!value || value === 'n/a') return false;
      if (opt.disabled || opt.hidden) return false;
      return true;
    }).length;
  }

  function countRadioLikeOptions(fieldEl) {
    if (!fieldEl) return 0;

    var options = Array.prototype.slice.call(
      fieldEl.querySelectorAll('.tee-radio, .tee-clipart, .tee-photo-placeholder, .tee-color, .tee-option')
    );

    return options.filter(function (opt) {
      if (opt.hasAttribute('disabled') || opt.getAttribute('aria-disabled') === 'true') return false;
      if (opt.hasAttribute('hidden') || opt.getAttribute('aria-hidden') === 'true') return false;
      if (opt.classList.contains('disabled') || opt.classList.contains('is-disabled')) return false;
      return true;
    }).length;
  }

  function countOptionsInField(fieldEl) {
    var selectEl = fieldEl.querySelector('select.tee-field__select');
    if (selectEl) return countSelectOptions(selectEl);
    return countRadioLikeOptions(fieldEl);
  }

  function hideSingleOptionFields() {
    if (isApplying) return;

    var teeFormInputs = document.getElementById('teeFormInputs');
    if (!teeFormInputs) return;

    isApplying = true;
    var fields = Array.prototype.slice.call(teeFormInputs.querySelectorAll('.tee-field'));
    try {
      fields.forEach(function (fieldEl) {
        var optionCount = countOptionsInField(fieldEl);
        if (optionCount > 0 && optionCount <= 1) {
          fieldEl.classList.add('tee-field--single-option-hidden');
        } else {
          fieldEl.classList.remove('tee-field--single-option-hidden');
        }
      });
    } finally {
      isApplying = false;
    }
  }

  function markTeeinblueProductForm() {
    var teeFormInputs = document.getElementById('teeFormInputs');
    if (!teeFormInputs) return;

    var productForm = teeFormInputs.closest('.product_form');
    if (productForm) {
      productForm.classList.add('teeinblue-product-form');
    }
  }

  function observeTeeFormChanges() {
    var teeFormInputs = document.getElementById('teeFormInputs');
    if (!teeFormInputs) return;

    if (formObserver) {
      formObserver.disconnect();
      formObserver = null;
    }

    formObserver = new MutationObserver(function () {
      scheduleApply();
    });

    formObserver.observe(teeFormInputs, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'hidden', 'aria-hidden', 'disabled', 'aria-disabled'],
    });

    teeFormInputs.addEventListener('change', scheduleApply);
    teeFormInputs.addEventListener('click', scheduleApply);
  }

  function initVariantCleanup() {
    markTeeinblueProductForm();
    hideSingleOptionFields();
    observeTeeFormChanges();
    setTimeout(scheduleApply, 300);
    setTimeout(scheduleApply, 1200);
  }

  document.addEventListener('teeinblue-event-component-injected', initVariantCleanup);

  document.addEventListener('DOMContentLoaded', function () {
    if (window.TeeInBlueCampaign && window.TeeInBlueCampaign.isTeeInBlueProduct) {
      initVariantCleanup();
    }
  });
})();
